import React from 'react';
import PropTypes from 'prop-types';
import { FieldList } from 'components';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import * as Permissions from 'permissions';
import { distance } from 'utils';

const copy = d => JSON.parse(JSON.stringify(d));

class MarkerOptions extends React.Component {
  static propTypes = {
    current_location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    })
  }
  constructor(props) {
    super(props);
    this.startCreatingMarker = this.startCreatingMarker.bind(this);
    this.handleCreateMarker = this.handleCreateMarker.bind(this);
    this.hanldeDeleteMarker = this.handleDeleteMarker.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderMarkerTypes = this.renderMarkerTypes.bind(this);
  }
  state = {
    creating: false,
    marker : {
      title: '',
      place: '',
      description: '',
      location: {
        'type': 'Point',
        coordinates: []
      }
    },
  }
  componentDidMount() {
    if(this.props.marker) {
      this.setState({marker});
    }
    this.props.initMapMarkerTypes();
  }
  handleChange(value, name) {
    let marker = copy(this.state.marker);
    marker[name] = value;
    this.setState({marker});
  }
  startCreatingMarker(type) {
    this.setState({creating: true, marker: {
      ...this.state.marker,
      type
    }});
  }
  handleCreateMarker() {
    const { place } = this.props;
    const placeLocation = {
      lng: place.geometry.location.lng(),
      lat: place.geometry.location.lat()
    }
    const userLocation = {
      ...this.props.current_location || {}
    };
    const distance_from_creator = this.props.current_location ? distance(placeLocation, userLocation) <= 152.4 : undefined
    const isVerified = this.props.current_location ? (
      distance_from_creator
    ) : false
    this.props.createMarker({
      ...this.state.marker,
      place: place.id,
      location : {
        type: 'Point',
        coordinates: [place.geometry.location.lng(),place.geometry.location.lat()]
      },
      verified: isVerified,
      distance_from_creator
    });

    this.setState({creating: false});
  }
  handleDeleteMarker(marker) {
    this.props.deleteMarker(marker);
  }
  renderMarkerTypes() {
    return (
      this.props.canvassing.marker_types && (this.props.canvassing.marker_types || []).length > 0 ?
      this.props.canvassing.marker_types.map(marker => {
        return (
          <span
            onClick={e => this.startCreatingMarker(marker.key)}
            className="btn btn-block btn-dark"
            >
            <div className='row'>
              <div className='col-md-2 col-xs-2 markers-image-wrapper'>
                <img
                  style={{height: '30px'}}
                  src={`assets/images/${marker.url}`}
                />
              </div>
              <div className='col-md-10 col-xs-10' style={{textAlign: 'left'}}>
                {marker.name}
              </div>
            </div>
          </span>
        )
      }) :
      <div className="alert alert-warning">
        <h3>Get Started!</h3>
        {this.props.hasPermission(Permissions.MANAGE_CANVASSING_MARKERS) ? <p>Click the settings icon and click "+ Create Marker Type" to create a custom marker type.</p> : <p>Your account doesn't have any canvassing marker types yet. Ask your administrator to create marker types so that you can canvas.</p>}
      </div>
    )
  }
  render() {
    if(!this.props.hasPermission(Permissions.CREATE_CANVASSING_MARKERS)) {
      return <noscript />
    }

    if(this.props.creating_marker) {
      return <div className="text-center"><i className="fa fa-spinner fa-spin fa-2x"></i> Saving marker...</div>
    }
    if(!this.props.place) {
      return <div>No place provided.</div>
    }
    if(this.state.creating) {
      return (
        <div>
        <FieldList
          entity={this.state.marker || {}}
          fields={[
            { _id: 0, type: 'text', flex: 12, name: 'title', label: 'Name', placeholder: 'Enter marker name.'}
          ]}
          onChange={this.handleChange}
        />
        <div onClick={e => this.handleCreateMarker()} className="animated pulse mt-sm btn btn-block btn-primary">Create Marker</div>
        <div onClick={e => this.setState({creating: false})} className="mt-sm btn btn-block btn-warning">Cancel</div>
        </div>
      )
    }
    return (
      <div className='animated fadeIn'>
        {this.renderMarkerTypes()}
      </div>
    )
  }
}

export default connect(({canvassing}) => ({canvassing}), Actions)(MarkerOptions);



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/marker-options.js